import { useMutation } from '@tanstack/react-query'
import { ReportFile } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request/request'

import { handlerServerError } from '@orbit/errors'

type UploadFileRequest = {
  file: File
  reportMonthlyId?: number
}

const uploadFile = ({ file, reportMonthlyId }: UploadFileRequest) => {
  const form = new FormData()
  form.append('file', file)
  if (reportMonthlyId) {
    form.append('reportMonthlyId', reportMonthlyId.toString())
  }
  return Request.post(Request.urls.bank.reportFileUpload, form)
}

export const useUploadFileCreate = (mrId: number, invalidateMR?: () => Promise<void>) => {
  const { mutateAsync: createFile, isPending } = useMutation<ReportFile, Error, UploadFileRequest>({
    mutationFn: (opts) => uploadFile(opts),
    onSuccess: () => {
      if (mrId && invalidateMR) invalidateMR()
    },
    onError: (error) => handlerServerError(error)
  })

  return {
    createFile,
    isPending
  }
}
